/** Способы входа — значения `authentication.controls.enabled|hidden` конфига приложения. */
export const CUSTOM_LOGIN_TYPE = 'CUSTOM';
export const SSO_LOGIN_TYPE = 'SSO';
export const SAML_LOGIN_TYPE = 'SAML';
